import React from 'react';
import { useLocation } from "react-router-dom";

import SecondApartament from './Components/SecondApartament';
import ThirdApartament from './Components/ThirdApartament';
import FourthApartament from './Components/FourthApartament';
import FifthApartament from './Components/FifthApartament';
import SixthApartament from './Components/SixthApartament';
import SeventhApartament from './Components/SeventhApartament';
import EighthApartament from './Components/EighthApartament';
import NinethApartament from './Components/NinethApartament';
import TenthApartament from './Components/TenthApartament';
import FirstApartament from './Components/FirstApartament';

function SameFloors() {
  const location = useLocation();

  const { customFloorUrl } = location.state || { customFloorUrl: "" };
  return (
    <div className="relative w-full mt-40 mb-40 lg:top-0">
      <div className="w-[100vw] relative lg:top-0 flex center">
        <img
          className='w-[100vw]'
          src="/images/click/clickable-images/Floors/Direct-floors/clean-floors/SameFloors.jpg"
          alt=""
        />
        <>
          <FirstApartament customFloorUrl={customFloorUrl} />
          <SecondApartament customFloorUrl={customFloorUrl} />
          <ThirdApartament customFloorUrl={customFloorUrl} />
          <FourthApartament customFloorUrl={customFloorUrl} />
          <FifthApartament customFloorUrl={customFloorUrl} />
          <SixthApartament customFloorUrl={customFloorUrl} />
          <SeventhApartament customFloorUrl={customFloorUrl} />
          <EighthApartament customFloorUrl={customFloorUrl} />
          <NinethApartament customFloorUrl={customFloorUrl} />
          <TenthApartament customFloorUrl={customFloorUrl} />
        </>
      </div>
    </div>
  );
}

export default SameFloors;
